var map = {
	"./cancel.svg": 46080,
	"./close-icon.svg": 31412,
	"./delete-icon.svg": 78843,
	"./edit-icon.svg": 72068,
	"./green-arrow-drop-down.svg": 61824,
	"./info-icon.svg": 99824,
	"./red-arrow-drop-down.svg": 31476,
	"./search.svg": 64118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14410;